import { Routes, Route } from 'react-router-dom';
import ComingSoon from './pages/ComingSoon';
import Landing from './pages/Landing';
import AuthDetail from './pages/AuthDetail';
import Dashboard from './pages/Dashboard';
import SiteLayout from './components/SiteLayout';

export default function App() {
  return (
    <div className="min-h-screen bg-page text-ink">
      <Routes>
        <Route path="/" element={<ComingSoon />} />
        <Route element={<SiteLayout />}>
          <Route path="/home" element={<Landing />} />
          <Route path="/auth" element={<AuthDetail />} />
          <Route path="/dashboard" element={<Dashboard />} />
        </Route>
      </Routes>
    </div>
  );
}
